import { View, StyleSheet } from "react-native";
import ClassCard from "../ClassCard/ClassCard";
import { classCardColors, DEFAULT_CLASS_COLOR } from "../../../constants/classCardColors";

function ClassCardList({ courses = [], onPress }) {
  return (
    <View role="list" accessibilityRole="list" aria-label="Classes cards" style={styles.container}>
      {courses.map((course, index) => {
        const color = classCardColors.find((color) => color.id === course.color)?.color ?? DEFAULT_CLASS_COLOR;

        return (
          <View key={course?.id ?? index} role="listitem" accessibilityRole="listitem">
            <ClassCard
              title={course?.name}
              description={course?.description}
              onPress={() => onPress(course?.id)}
              color={color}
            />
          </View>
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
  },
});

export default ClassCardList;
